import React, { FC } from 'react';
import './Button.css';
import { motion } from "framer-motion"

interface ButtonProps {
  label: String;
  onClick: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  className?: String;
}

export const Button: FC<ButtonProps> = ({ label, onClick, className }) => {
  return (
    <motion.button whileHover={{ scale: 1.05 }} className={`button ${className}`} onClick={onClick}>
      {label}
    </motion.button>
  )
}